import Blue from '~/core'

new Blue({
  name: 'Video',
  selector: '.video',
  setup(video) {
    const youtube = video.querySelector('.video__youtube')
    if (youtube === null) {
      return
    }
    const source = youtube.dataset.poster ? youtube.dataset.poster : `https://img.youtube.com/vi/${youtube.dataset.embed}/sddefault.jpg`

    const image = new Image()
    image.src = source
    image.addEventListener('load', function () {
      youtube.appendChild(image)
    })

    youtube.addEventListener('click', function () {
      const iframe = document.createElement('iframe')

      iframe.setAttribute('frameborder', '0')
      iframe.setAttribute('allowfullscreen', '')
      iframe.setAttribute(
        'src',
        'https://www.youtube.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1&cc_load_policy=' + this.dataset.closedcaption + '&cc_lang_pref=en"',
      )

      this.innerHTML = ''
      this.appendChild(iframe)
    })
  },
})
